import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="footer position-relative dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          {/* About Section */}
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="#hero" className="logo d-flex align-items-center">
              <span className="sitename">Autobotics</span>
            </a>
            <div className="footer-contact pt-3">
              <p>236, Aristo </p>
              <p>Vadodara, Gujarat India 390021</p>
              <p className="mt-3">
                <strong>Phone:</strong> <span>+91 63523 00594</span>
              </p>
              <p>
                <strong>Email:</strong> <span>hello@autobotics.co.in</span>
              </p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          {/* Useful Links */}
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="#hero">Home</a></li>
              <li><a href="#about">About us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#ScheduleCall">Schedule a Call</a></li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><a href="#services">AI Agents</a></li>
              <li><a href="#services">Workflow Automations</a></li>
              <li><a href="#services">AI Voice Agents</a></li>
              <li><a href="#services">Web Development</a></li>
              <li><a href="#services">Digital Marketing</a></li>
            </ul>
          </div>

          {/* Column 3 */}
          {/* <div className="col-lg-2 col-md-3 footer-links">
            <h4>Hic solutasetp</h4>
            <ul>
              <li><a href="#">Molestiae accusamus iure</a></li>
              <li><a href="#">Excepturi dignissimos</a></li>
              <li><a href="#">Suscipit distinctio</a></li>
              <li><a href="#">Dilecta</a></li>
              <li><a href="#">Sit quas consectetur</a></li>
            </ul>
          </div> */}

          {/* Column 4 */}
          {/* <div className="col-lg-2 col-md-3 footer-links">
            <h4>Nobis illum</h4>
            <ul>
              <li><a href="#">Ipsam</a></li>
              <li><a href="#">Laudantium dolorum</a></li>
              <li><a href="#">Dinera</a></li>
              <li><a href="#">Trodelas</a></li>
              <li><a href="#">Flexo</a></li>
            </ul>
          </div> */}
        </div>
      </div>

      {/* Copyright Section */}
      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">Autobotics</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
        {/* <div className="credits">
          Designed by{" "}
          <a href="https://autobotics.co.in/" target="_blank" rel="noreferrer">
            Autobotics
          </a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;